import React, { useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import { EncryptData } from "../utils/encryptDecrypt";

export default function SetLanguage() {
    const navigate = useNavigate()
    const search = useLocation().search;
    const language = new URLSearchParams(search).get('lang');

    useEffect(() => {
        localStorage.setItem('lang', EncryptData(language));
        setTimeout(() => navigate('/dashboard'), 1000)
    }, [])

    return (
        <>
            Redirecting.....
        </>
    );
}